var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { theme } from 'src/Utils';
export var MapContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 260px;\n  border-radius: 16px;\n  border: 1px solid ", ";\n  margin-top: 24px;\n  overflow: hidden;\n"], ["\n  width: 100%;\n  height: 260px;\n  border-radius: 16px;\n  border: 1px solid ", ";\n  margin-top: 24px;\n  overflow: hidden;\n"])), theme.palette.grey[55]);
var templateObject_1;
